<template>
<div>
  <v-row no-gutters justify="center" class="pt-3" style="height:196px;" v-show="isLoading">
    <div class="donutSpinner"></div>
  </v-row>
  <div v-show="!isLoading">
    <v-row no-gutters>
      <v-col :cols="3" class="pt-3 d-none d-sm-block">
        <v-row no-gutters justify="center">
          <svg version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="width: 108px; height: 108px; opacity: 1;" xml:space="preserve">
            <g>
              <path class="st0" d="M144.416,180.644c0-23.685-19.197-42.882-42.891-42.882h-8.772c-23.694,0-42.892,19.197-42.892,42.882v240.779
                h94.554V180.644z" style="fill: rgb(58, 171, 210);"></path>
              <path class="st0" d="M332.831,213.451c-5.014,6.713-7.756,14.848-7.756,23.352c0,10.499,4.063,20.241,11.44,27.608
                c7.378,7.378,17.212,11.441,27.61,11.441c10.406,0,20.24-4.063,27.609-11.339c13.906-13.906,15.134-35.744,3.592-51.063H332.831z" style="fill: rgb(58, 171, 210);"></path>
              <path class="st0" d="M364.124,370.313c-17.203,0-34.036-3.306-49.539-9.455v60.611h94.544v-58.912
                C394.854,367.664,379.637,370.313,364.124,370.313z" style="fill: rgb(58, 171, 210);"></path>
              <path class="st0" d="M276.763,337.691c-2.465-1.985-4.728-4.155-6.999-6.426c-25.246-25.246-39.059-58.718-39.059-94.462
                c0-35.642,13.813-69.114,39.059-94.36c2.271-2.271,4.534-4.451,6.999-6.435V67.225c0-23.685-19.207-42.882-42.89-42.882h-8.782
                c-23.684,0-42.881,19.197-42.881,42.882v354.244h94.554V337.691z" style="fill: rgb(58, 171, 210);"></path>
              <path class="st0" d="M503.433,343.499l-51.016-49.696c10.878-16.823,16.769-36.417,16.769-56.963
                c0-28.107-10.924-54.497-30.749-74.322c-19.825-19.825-46.215-30.749-74.322-30.749c-28.108,0-54.498,10.924-74.332,30.749
                c-19.824,19.825-30.748,46.215-30.748,74.322c0,28.108,10.924,54.507,30.748,74.332c19.834,19.824,46.224,30.748,74.332,30.748
                c20.544,0,40.148-5.9,56.972-16.778l49.678,50.998c9.261,11.163,22.927,11.828,33.491,1.264
                C514.828,366.851,514.597,352.733,503.433,343.499z M364.115,293.231c-15.06,0-29.224-5.873-39.881-16.52
                c-10.647-10.646-16.51-24.811-16.51-39.871c0-15.06,5.863-29.215,16.51-39.862c10.656-10.647,24.811-16.52,39.881-16.52
                c15.051,0,29.215,5.873,39.862,16.52c21.986,21.986,21.986,57.757,0,79.743C393.33,287.367,379.174,293.231,364.115,293.231z" style="fill: rgb(58, 171, 210);"></path>
              <rect x="0" y="449.835" class="st0" width="453.858" height="37.822" style="fill: rgb(58, 171, 210);"></rect>
            </g>
          </svg>
        </v-row>
      </v-col>
      <v-col :cols="9" class="pt-3 d-none d-sm-block">
        <v-row no-gutters class="px-5 my-1">
          <span class="summary-amount-x-lg" style="display:inline-block">{{ dispUriageKingakuCurrent }}</span>
          <span class="pl-2 summary-text-x-lg" style="display:inline-block">円</span>
        </v-row>
        <v-row no-gutters class="px-5 mb-1">
          <v-chip class="mx-1" color="#00B050" pill >
            <v-icon class="pl-1" color="#FFF">mdi-truck-outline</v-icon>
            <span class="pl-1 chip-text" style="color:#FFF">配送数：</span>
            <span class="px-1 chip-text" style="color:#adff2f">{{ dispUnkoCountCurrent }}</span>
          </v-chip>
          <v-chip class="mx-1" color="#0070C0" pill >
            <v-icon class="pl-1" color="#FFF">mdi-file-table-outline</v-icon>
            <span class="pl-1 chip-text" style="color:#FFF">受付数：</span>
            <span class="px-1 chip-text" style="color:#adff2f">{{ dispUriageCountCurrent }}</span>
          </v-chip>
        </v-row>
        <v-row no-gutters class="px-5">
          <div>
            <span class="px-1 standard-black">（集計期間：</span>
            <span class="standard-black-lg">{{ dispYmdFrom }}</span>
            <span class="px-1 standard-black">~</span>
            <span class="standard-black-lg">{{ dispYmdTo }}</span>
            <span class="px-1 standard-black">）</span>
          </div>
        </v-row>
        <v-row no-gutters class="mt-3 px-5" v-if="uriageYmIndex < 12">
          <span class="standard-black-lg" style="font-weight:bold;margin-top:2px">{{ dispYmPrev }}</span>
          <span class="px-2 pt-1 standard-black">の売上は</span>
          <span class="summary-amount-lg">{{ dispUriageKingakuPrev }}</span>
          <span class="pl-2 pt-1 standard-black">円でした</span>
        </v-row>
      </v-col>
      <v-col :cols="12" class="px-5 block-xs-and-down hidden-sm-and-up">
        <v-row no-gutters class="px-5 pt-3 pb-0">
          <div class="summary-amount-x-lg">{{ dispUriageKingakuCurrent }}</div>
          <div class="pl-2 summary-text-x-lg">円</div>
        </v-row>
        <v-row no-gutters class="px-5">
          <div>
            <span class="px-1 standard-black">（集計期間：</span>
            <span class="standard-black-lg">{{ dispYmdFrom }}</span>
            <span class="px-1 standard-black">~</span>
            <span class="standard-black-lg">{{ dispYmdTo }}</span>
            <span class="px-1 standard-black">）</span>
          </div>
        </v-row>
        <v-row no-gutters class="mt-3 px-5" v-if="uriageYmIndex < 12">
          <span class="standard-black-lg" style="margin-top:2px">{{ dispYmPrev }}</span>
          <span class="px-2 pt-1 standard-black">の売上は</span>
          <span class="summary-amount-lg">{{ dispUriageKingakuPrev }}</span>
          <span class="pl-2 pt-1 standard-black">円でした</span>
        </v-row>
      </v-col>
    </v-row>
  </div>
</div>
</template>
<script>
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import date from '@/ddv2.library/date'

export default {
  name: 'DdNenpiSummaryDisp',
  mixins: [flowMixin],
  props: {
    // 売上年月リスト
    uriageYmList: Array,
    // 売上年月インデックス
    uriageYmIndex: Number
  },
  components: {
  },
  data: () => ({
    dataList: [],
    dispYmdFrom: null,
    dispYmdTo: null,
    isLoading: false
  }),
  created () {
  },
  mounted () {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    dispUriageKingakuCurrent () {
      if (this.dataList.length === 0) return '0'

      const self = this
      const targetIndex = this.dataList.findIndex((item) => item.uriageYm === self.uriageYmList[self.uriageYmIndex])
      if (targetIndex >= 0) {
        return filter.numericFormatter(self.dataList[targetIndex].uriageKingaku) + ''
      } else {
        return '0'
      }
    },
    dispUnkoCountCurrent () {
      if (this.dataList.length === 0) return '0'

      const self = this
      const targetIndex = this.dataList.findIndex((item) => item.uriageYm === self.uriageYmList[self.uriageYmIndex])
      if (targetIndex >= 0) {
        return filter.numericFormatter(self.dataList[targetIndex].unkoCount) + ''
      } else {
        return '0'
      }
    },
    dispUriageCountCurrent () {
      if (this.dataList.length === 0) return '0'

      const self = this
      const targetIndex = this.dataList.findIndex((item) => item.uriageYm === self.uriageYmList[self.uriageYmIndex])
      if (targetIndex >= 0) {
        return filter.numericFormatter(self.dataList[targetIndex].uriageCount) + ''
      } else {
        return '0'
      }
    },
    dispYmPrev () {
      if (this.uriageYmList === undefined || this.uriageYmList.length === 0) return ''
      if ([undefined, null, 12].includes(this.uriageYmIndex)) return ''

      const ym = (this.uriageYmList[this.uriageYmIndex + 1]).split('/')
      return ym[0] + '年' + ym[1] + '月'
    },
    dispUriageKingakuPrev () {
      if (this.dataList.length === 0 || this.uriageYmIndex === 12) return '0'

      const self = this
      const targetIndex = this.dataList.findIndex((item) => item.uriageYm === self.uriageYmList[self.uriageYmIndex + 1])
      if (targetIndex >= 0) {
        return filter.numericFormatter(self.dataList[targetIndex].uriageKingaku) + ''
      } else {
        return '0'
      }
    }
  },
  methods: {
    searchUriageSummary: function () {
      this.isLoading = true
      const self = this
      console.log('searchUriageSummary')
      self.HttpClient.get('/api/v1/VwCD2comd000001/GetAll')
        .then((data) => {
          self.dataList = data.payload

          const ym = (self.uriageYmList[self.uriageYmIndex]).split('/')
          self.dispYmdFrom = date.getFirstDate(ym[0], ym[1])
          self.dispYmdTo = self.uriageYmIndex === 0 ? date.getCurrentDate() : date.getLastDate(ym[0], ym[1])

          this.isLoading = false
        })
    }
  }
}
</script>
<style scoped>
.standard-black-lg {
  font-size:large;
  color:#1F2B38;
}
.standard-black {
  color:#1F2B38;
}
.summary-amount-x-lg {
  text-align: end !important;
  font: normal normal bold 3.375rem/4.0rem YuGothic !important;
  letter-spacing: 0px !important;
  color: #3178c5;
}
.summary-text-x-lg {
    text-align: start !important;
    font: normal normal 2.1rem YuGothic !important;
    letter-spacing: 0px !important;
    margin-top: 14px;
    color: #1F2B38;
}
.summary-amount-lg {
  text-align: end !important;
  font: normal normal bold 1.5rem/1.8rem YuGothic !important;
  letter-spacing: 0px !important;
  color: #3178c5;
}
.chip-text {
  font: normal normal 1.05rem YuGothic !important;
}

.donutSpinner {
  display: inline-block;
  border: 4px solid #E5EDFF;
  border-left-color: #5850EB;
  border-radius: 50%;
  width: 150px;
  height: 150px;
  animation: donut-spin 1.2s linear infinite;
}

@keyframes donut-spin {
  to {
    transform: rotate(1turn);
  }
}
</style>
